/**
 * 25 makalelik test seti manifesti.
 *
 * Bu liste, Faz 1 doğrulama veri setinin şemasını gösterir. `title`, `doi` vb.
 * alanlar kurgusal örnektir; kendi veri setinizle değiştirilebilir. Araç
 * manifesti yalnızca ilerleme takibi için okur — makale dosyaları kullanıcıdan
 * gelir, dışarıdan indirilmez.
 */

export interface TestSetEntry {
	id: string;
	title: string;
	authors: string;
	year: number;
	outlet: string;
	doi?: string;
	category: 'psikoloji' | 'eğitim' | 'sosyal bilim' | 'sağlık';
	/** Bu makalede beklenen asıl risk. */
	focus: string;
}

export const TEST_SET: TestSetEntry[] = [
	{
		id: 'TR-01',
		title: 'Ergenlerde Sosyal Medya Kullanımı ve Yalnızlık Algısı',
		authors: 'Yılmaz, A.; Demir, S.',
		year: 2021,
		outlet: 'Türk Psikoloji Dergisi',
		category: 'psikoloji',
		focus: 'Korelasyonel desende nedensel dil'
	},
	{
		id: 'TR-02',
		title: 'Öğretmenlerde Tükenmişlik ve Öz-Yeterlik İlişkisi',
		authors: 'Kaya, M.; Şahin, R.',
		year: 2020,
		outlet: 'Eğitim ve Bilim',
		category: 'eğitim',
		focus: 'p değeri / test istatistiği çelişkisi'
	},
	{
		id: 'TR-03',
		title: 'Üniversite Öğrencilerinde Akademik Erteleme ve Mükemmeliyetçilik',
		authors: 'Öztürk, B.; Aydın, M.',
		year: 2019,
		outlet: 'Psikoloji Çalışmaları',
		category: 'psikoloji',
		focus: 'Kaynakçada eksik atıf'
	},
	{
		id: 'TR-04',
		title: 'Sağlık Çalışanlarında İş Stresi ve Uyku Kalitesi',
		authors: 'Çelik, H.; Arslan, T.',
		year: 2022,
		outlet: 'Sağlık Bilimleri Dergisi',
		category: 'sağlık',
		focus: 'Çoklu test düzeltmesi yapılmamış'
	},
	{
		id: 'TR-05',
		title: 'Bilişsel Davranışçı Terapinin Sınav Kaygısına Etkisi: Randomize Kontrollü Çalışma',
		authors: 'Doğan, E.; Kılıç, N.',
		year: 2023,
		outlet: 'Klinik Psikoloji Dergisi',
		category: 'psikoloji',
		focus: 'Deneysel desen; etki büyüklüğü eksik'
	},
	{
		id: 'TR-06',
		title: 'Okul Öncesi Dönemde Ekran Süresi ve Dil Gelişimi',
		authors: 'Şen, C.; Yıldız, P.',
		year: 2021,
		outlet: 'Erken Çocukluk Çalışmaları Dergisi',
		category: 'eğitim',
		focus: 'Operatör kaybı (p , .05)'
	},
	{
		id: 'TR-07',
		title: 'Genç Yetişkinlerde Benlik Saygısı ve Sosyal Karşılaştırma',
		authors: 'Aksoy, D.; Erdem, K.',
		year: 2018,
		outlet: 'Türk Psikoloji Yazıları',
		category: 'psikoloji',
		focus: 'Tabloya metinde atıf yok'
	},
	{
		id: 'TR-08',
		title: 'Öğretmen Adaylarında Eleştirel Düşünme Eğilimleri',
		authors: 'Polat, S.; Güneş, A.',
		year: 2020,
		outlet: 'Eğitim Bilimleri Araştırmaları Dergisi',
		category: 'eğitim',
		focus: 'Bölüm sırası bozuk (bulgular yöntemden önce)'
	},
	{
		id: 'TR-09',
		title: 'Pandemi Döneminde Uzaktan Çalışma ve İş-Yaşam Dengesi',
		authors: 'Tekin, A.; Barut, M.',
		year: 2022,
		outlet: 'Çalışma ve Toplum',
		category: 'sosyal bilim',
		focus: 'Genelleme / aşırı iddia'
	},
	{
		id: 'TR-10',
		title: 'Göçmen Çocuklarda Akran İlişkileri ve Aidiyet',
		authors: 'Karaca, L.; Uysal, F.',
		year: 2023,
		outlet: 'Göç Dergisi',
		category: 'sosyal bilim',
		focus: 'Nitel veride istatistiksel anlamlılık iddiası'
	},
	{
		id: 'TR-11',
		title: 'Duygusal Zekâ ve Çatışma Çözme Stratejileri',
		authors: 'Arı, G.; Özkan, H.',
		year: 2019,
		outlet: 'Psikoloji Araştırmaları Dergisi',
		category: 'psikoloji',
		focus: 'df eksik bildirim'
	},
	{
		id: 'TR-12',
		title: 'Hemşirelerde Presenteizm ve Tükenmişlik',
		authors: 'Bozkurt, M.; Sezer, N.',
		year: 2021,
		outlet: 'Hemşirelik Bilimi Dergisi',
		category: 'sağlık',
		focus: 'Kaynakçada atıfsız girdi'
	},
	{
		id: 'TR-13',
		title: 'İnternet Bağımlılığı ve Dikkat Süreçleri',
		authors: 'Yalçın, T.; Koç, E.',
		year: 2017,
		outlet: 'Türk Psikoloji Dergisi',
		category: 'psikoloji',
		focus: 'Ondalık virgül tutarlılığı'
	},
	{
		id: 'TR-14',
		title: 'Öz-Şefkatin Depresyon Belirtileri Üzerindeki Rolü',
		authors: 'Altun, S.; Gürbüz, A.',
		year: 2022,
		outlet: 'Klinik Psikoloji Dergisi',
		category: 'psikoloji',
		focus: 'Regresyon tablosunda p tutarsızlığı'
	},
	{
		id: 'TR-15',
		title: 'Okula Yabancılaşma ve Akademik Motivasyon',
		authors: 'Demirtaş, R.; Acar, B.',
		year: 2018,
		outlet: 'Eğitim ve Bilim',
		category: 'eğitim',
		focus: 'Anlamlılık iddiası, test istatistiği yok'
	},
	{
		id: 'TR-16',
		title: 'Evli Çiftlerde İletişim Kalıpları ve Evlilik Doyumu',
		authors: 'Sönmez, K.; Yavuz, D.',
		year: 2020,
		outlet: 'Aile Psikolojisi Dergisi',
		category: 'psikoloji',
		focus: 'Şekle metinde atıf yok'
	},
	{
		id: 'TR-17',
		title: 'Bilim İnsanlarında İşbirlikçi Ağlar ve Yayın Verimliliği',
		authors: 'Ekinci, M.; Tanrıkulu, O.',
		year: 2021,
		outlet: 'Yükseköğretim Dergisi',
		category: 'sosyal bilim',
		focus: 'Nedensel dil (sosyal ağ analizi)'
	},
	{
		id: 'TR-18',
		title: 'Adölesanlarda Fiziksel Aktivite ve Duygusal İyi Oluş',
		authors: 'Kurt, A.; Öz, S.',
		year: 2023,
		outlet: 'Sağlık Bilimleri Dergisi',
		category: 'sağlık',
		focus: 'Kaynakça bölümü bulunamadı'
	},
	{
		id: 'TR-19',
		title: 'Öğretmen Tutumları ve Öğrenci Katılımı: Çok Düzeyli Analiz',
		authors: 'Atalay, N.; Çoban, R.',
		year: 2022,
		outlet: 'İlköğretim Online',
		category: 'eğitim',
		focus: 'F df bildirimi eksik'
	},
	{
		id: 'TR-20',
		title: 'Kadın Girişimcilerde Öz-Yeterlik ve Risk Alma',
		authors: 'Bulut, P.; Şimşek, E.',
		year: 2021,
		outlet: 'Sosyal Bilimler Dergisi',
		category: 'sosyal bilim',
		focus: 'p değeri istatistikle çelişiyor'
	},
	{
		id: 'TR-21',
		title: 'Dikkat Eksikliği Hiperaktivite Bozukluğunda İlaç Uyumu',
		authors: 'Işık, T.; Ersoy, G.',
		year: 2019,
		outlet: 'Çocuk ve Gençlik Ruh Sağlığı Dergisi',
		category: 'sağlık',
		focus: 'Taranmış PDF (metin katmanı yok)'
	},
	{
		id: 'TR-22',
		title: 'Kırsal ve Kentsel Okullarda Teknoloji Kullanımı',
		authors: 'Çiftçi, A.; Kara, H.',
		year: 2017,
		outlet: 'Eğitim Teknolojisi Kuram ve Uygulama',
		category: 'eğitim',
		focus: 'Tablo numaralandırma boşluğu'
	},
	{
		id: 'TR-23',
		title: 'Mülteci Kadınlarda Stresle Başa Çıkma',
		authors: 'Sarı, Z.; Keskin, M.',
		year: 2023,
		outlet: 'Toplum ve Sosyal Hizmet',
		category: 'sosyal bilim',
		focus: 'Nitel desende "kanıtlamaktadır"'
	},
	{
		id: 'TR-24',
		title: 'Sporcularda Zihinsel Dayanıklılık ve Performans',
		authors: 'Güneş, B.; Yücel, D.',
		year: 2020,
		outlet: 'Spor Bilimleri Dergisi',
		category: 'sağlık',
		focus: 'r için n eksik'
	},
	{
		id: 'TR-25',
		title: 'Üniversite Öğrencilerinde Nomofobi ve Akademik Başarı',
		authors: 'Toprak, S.; Er, N.',
		year: 2022,
		outlet: 'Bağımlılık Dergisi',
		category: 'psikoloji',
		focus: 'Karma bulgu: birden çok orta düzey sorun'
	}
];
